import React, { FC } from 'react';
import manifest from './site.json';
import { SiteManifest, SiteModuleProps } from '../../customFrontend/types';
import Home from './Home';
import CityPage from './CityPage';
import { CITIES } from './cities';
import './matureflirt.scss';

const site = manifest as SiteManifest;

/** matureflirt.net: mature flirt chat for Australia, Australian English. See ../CLAUDE.md. */
const MatureFlirt: FC<SiteModuleProps> = ({ path }) => {
  const page = site.pages.find((candidate) => candidate.path === path) ?? site.pages[0]!;
  const city = CITIES[page.path];
  return (
    <div className="site-matureflirt" lang={site.language}>
      {page.type === 'city' && city
        ? <CityPage site={site} page={page} city={city} />
        : <Home site={site} page={page} />}
    </div>
  );
};

export default MatureFlirt;
